module.exports = __webpack_public_path__ + "img/user-info_icon.50489172.svg";